var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMountains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 87,
    viewBox: "0 0 116 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8583 2.05061C68.4369 -0.683533 72.3833 -0.683539 73.9618 2.0506L114.807 72.7966C116.386 75.5307 114.412 78.9484 111.255 78.9484H62.7114L63.4724 80.2665C65.051 83.0007 63.0778 86.4184 59.9206 86.4184H4.10733C0.950212 86.4184 -1.02298 83.0007 0.555578 80.2665L28.4622 31.9308C30.0408 29.1966 33.9872 29.1966 35.5657 31.9308L42.5864 44.0908L66.8583 2.05061ZM15.5196 19.0881C19.4342 19.0881 22.6077 15.9146 22.6077 12C22.6077 8.08532 19.4342 4.91187 15.5196 4.91187C11.605 4.91187 8.4315 8.08532 8.4315 12C8.4315 15.9146 11.605 19.0881 15.5196 19.0881Z",
    fill: "#AEAEAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains);
export default __webpack_public_path__ + "static/media/mountains.d3bc1c3e867bd26368939a1b103d40b0.svg";
export { ForwardRef as ReactComponent };